module.exports = __webpack_public_path__ + "static/media/pt.fbb18d16.png";